__turbopack_context__.v({
  "fallbackNoticeWrapper": "PlasmicServiceMessage-module__0mb2QG__fallbackNoticeWrapper",
  "fallbackServiceMessage": "PlasmicServiceMessage-module__0mb2QG__fallbackServiceMessage",
  "noticeWrapper": "PlasmicServiceMessage-module__0mb2QG__noticeWrapper",
  "notice__liYp8": "PlasmicServiceMessage-module__0mb2QG__notice__liYp8",
  "notice__tNXy7": "PlasmicServiceMessage-module__0mb2QG__notice__tNXy7",
  "serviceDataProvider": "PlasmicServiceMessage-module__0mb2QG__serviceDataProvider",
});
